export default __webpack_public_path__ + "static/media/eggMove.7a9c3816.gif";